import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

function MissingDataLabel({ ...props }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage"
  });

  return <Text fontSize="lg" fontWeight="bold" marginTop={5} {...props}>
    {t("missingDataError")}
  </Text>;
}

export default MissingDataLabel;